import moment from 'moment'

export default {
  name: 'monthlyCalendar',
  inject: [
    '$utils'
  ],
  props: {
    monthlyCalendarTypeProp: {
      type: String,
      default () { return 'currentMonth' }
    },
    selectedDayProp: {
      type: Object,
      default () { return {} }
    }
  },
  watch: {
    selectedDayProp (newSelectedDayVal) {
      this.selectedDay = newSelectedDayVal
    }
  },
  data () {
    return {
      calendar: null,
      selectedDay: this.selectedDayProp,
      monthlyCalendarType: this.monthlyCalendarTypeProp,
      calendarOptions: {
        days: {
          sun: { name: 'Sun', text: this.$t('label.sun') },
          mon: { name: 'Mon', text: this.$t('label.mon') },
          tue: { name: 'Tue', text: this.$t('label.tue') },
          wed: { name: 'Wed', text: this.$t('label.wed') },
          thu: { name: 'Thu', text: this.$t('label.thu') },
          fri: { name: 'Fri', text: this.$t('label.fri') },
          sat: { name: 'Sat', text: this.$t('label.sat') }
        }
      }
    }
  },
  methods: {
    emitEvent (action, data) {
      if (action !== null || action.length > 0) {
        this.$emit('monthly-calendar-change', { action, payload: { data } })
      }
    },
    createMonthlyCalendar (calType) {
      const monthCalendar = {
        title: '',
        monthId: '',
        body: []
      }

      let startOfMonth = moment().startOf('month')
      let endOfMonth = moment().endOf('month')

      if (calType === 'nextMonth') {
        const getNextMonth = moment().add(1, 'M')
        startOfMonth = getNextMonth.clone().startOf('month')
        endOfMonth = getNextMonth.clone().endOf('month')
      }

      // Set Title
      monthCalendar.title = this.$t('el.datepicker.months.' + startOfMonth.clone().format('MMM').toLowerCase()) + ' ' + startOfMonth.clone().format('YYYY')
      monthCalendar.monthId = startOfMonth.clone().format('M')

      // Get the start and end day of the month. This returns the day of the week (0-6) where 0 = Sunday, 1 = Monday, etc.
      let startDow = startOfMonth.day()
      let endDow = endOfMonth.day()

      // If calendar week starts on Monday, recalculate startDow and endDow so that we treat Monday = 0 instead of Sunday = 0
      const weekStart = this.$utils.getCalendarWeekStart(navigator.language)
      if (weekStart === 1) {
        startDow = (startOfMonth.day() + 6) % 7
        endDow = (endOfMonth.day() + 6) % 7

        this.calendarOptions.days = {
          mon: { name: 'Mon', text: this.$t('label.mon') },
          tue: { name: 'Tue', text: this.$t('label.tue') },
          wed: { name: 'Wed', text: this.$t('label.wed') },
          thu: { name: 'Thu', text: this.$t('label.thu') },
          fri: { name: 'Fri', text: this.$t('label.fri') },
          sat: { name: 'Sat', text: this.$t('label.sat') },
          sun: { name: 'Sun', text: this.$t('label.sun') }
        }
      }

      // To show full weeks, we need to subtract/add from the start and end of the month
      // If the month didn't start on a Monday/Sunday, start from the last Monday/Sunday of the previous month
      startOfMonth.subtract(startDow, 'd')

      // If the month didn't end on a Sunday/Saturday, end on the following Sunday/Saturday in the next month
      endOfMonth.add((6 - endDow), 'd')

      let week = []
      let day = moment(startOfMonth)
      while (day <= moment(endOfMonth)) {
        const dayDetails = {
          day: moment(day.toDate()).format('ddd'),
          date: moment(day.toDate()).format('DD'),
          month: moment(day.toDate()).format('MMM'),
          monthId: moment(day.toDate()).format('M'),
          fullDate: moment(day.toDate()).format('YYYY-MM-DD'),
          isVisible: true
        }

        // Hide Days
        const setMN = { hour: '00', minute: '00', second: '00' }

        // If calendar is for the current month then hide those past days and days belongs to the next month
        if (calType === 'currentMonth') {
          const dayItemIsToday = moment().set(setMN).format('YYYY-MM-DD') === dayDetails.fullDate

          // Past Days
          if (moment(dayDetails.fullDate).set(setMN) < moment().set(setMN) && !dayItemIsToday) {
            dayDetails.isVisible = false
          }

          if (moment(dayDetails.fullDate).set(setMN) > moment().endOf('month').set(setMN)) {
            dayDetails.isVisible = false
          }
        }

        // If calendar is for the next month then hide those days belongs to the current month and days blongs to the next month
        if (calType === 'nextMonth') {
          const asNextMonth = moment().add(1, 'M')

          if (moment(dayDetails.fullDate).set(setMN) < asNextMonth.clone().startOf('month').set(setMN)) {
            dayDetails.isVisible = false
          }

          if (moment(dayDetails.fullDate).set(setMN) > asNextMonth.clone().endOf('month').set(setMN)) {
            dayDetails.isVisible = false
          }
        }

        week.push(dayDetails)

        if (week.length === 7) {
          monthCalendar.body.push(week)
          week = []
        }
        day = day.clone().add(1, 'd')
      }

      this.calendar = monthCalendar
    },
    /**
     * Handle Day Selection in the calendar
     * @param {Object} day
     */
    handleDaySelection (day) {
      if (this.selectedDay.fullDate !== day.fullDate) {
        this.selectedDay = day
        this.emitEvent('DAY_SELECTION', this.selectedDay)
      }
    }
  },
  mounted () {
    this.createMonthlyCalendar(this.monthlyCalendarType)
  }
}
